import { FileReadSuccess } from 'components/common/graphicUploader/types';
import { DocumentationCreateModel } from 'shared/domain/documentation/documentationModel';
import { getConvertableStatus } from 'shared/domain/documentation/getConvertableStatus';
import { UserWithPersonalData } from 'shared/domain/user/types/model';
import { ImageRotation } from 'shared/dtos/out/document';
import { UploadStatus } from 'shared/types/uploadStatus';
import { nowISO } from 'shared/utils/date/dates';
import { removeFileExtension } from 'shared/utils/fileExtensions';

export function fileToCreateDocumentationModel(
  file: FileReadSuccess,
  author: UserWithPersonalData,
  currentDirectory: string
): DocumentationCreateModel {
  const extension = file.data?.extension || '';
  const now = nowISO();
  const imageConvertStatus = getConvertableStatus(extension);

  return {
    name: removeFileExtension(file.title),
    deleted: 0,
    parentId: currentDirectory,
    createdAt: now,
    createdBy: author,
    modifiedAt: now,
    modifiedBy: author,
    versions: [
      {
        name: removeFileExtension(file.title),
        extension: extension,
        remoteVersionId: '',
        uploadStatus: UploadStatus.unknown,
        localData: file.downloadSrc,
        createdAt: now,
        createdBy: author,
        modifiedAt: now,
        modifiedBy: author,
        type: file.type,
        imageConvertStatus,
        imageRotation: file.imageRotation,
      },
    ],
  };
}
